import { IRGB } from '/druid/interfaces';
import { hsl2hsv } from '/druid/hsl2hsv';
import { hsv2rgb } from '/druid/hsv2rgb';

/** Converts HSL components to an RGB color. Does not set the alpha value. */
export function hsl2rgb(h: number, s: number, l: number): IRGB {
  const hsv = hsl2hsv(h, s, l);

  return hsv2rgb(hsv.h, hsv.s, hsv.v);
}
